import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import {
    BlockType,
    Setting,
    SettingType,
    Define,
    ValidationMessage,
    SettingState,
    TibboDataType,
    AppBlockPort,
} from '@appblocks/codegeneration/types';

export default class ConditionExpression extends BaseFeature {
    constructor() {
        super();
        this.name = 'Condition Expression';
        this.id = 'condition_expression';
        this.fileLinks = [

        ];

        const settings = [
            {
                id: 'LEFT_OPERAND',
                name: 'Left Operand',
                settingType: SettingType.STRINGVARIABLE,
                required: true,
                default: '',
            },
            {
                id: 'OPERATOR',
                name: 'Operator',
                settingType: SettingType.OPTION,
                required: true,
                options: [
                    {
                        name: '==',
                        value: '=',
                    },
                    {
                        name: '!=',
                        value: '!=',
                    },
                    {
                        name: '>',
                        value: '>',
                    },
                    {
                        name: '>=',
                        value: '>=',
                    },
                    {
                        name: '<',
                        value: '<',
                    },
                    {
                        name: '<=',
                        value: '<=',
                    },
                ],
                default: '=',
            },
            {
                id: 'RIGHT_OPERAND',
                name: 'Right Operand',
                settingType: SettingType.STRINGVARIABLE,
                required: true,
                default: '',
            },
        ];

        this.settings = this.settings.concat(settings);
    }

    getInputs(): AppBlockPort[] {
        const project = this.project;
        const parent = project.getParent(this);
        return parent.getInputs();
    }

    getOutputs(): AppBlockPort[] {
        const project = this.project;
        const parent = project.getParent(this);
        return parent.getOutputs();
    }

    validate(): Array<ValidationMessage> {
        const errors: Array<ValidationMessage> = [];
        return errors;
    }
}
